import { Component, Inject } from '@angular/core';
import { INFORMATIVE_FAKE_CALL_CENTER, INFORMATIVE_MOBILE, INFORMATIVE_ROBBERY, INFORMATIVE_WHATSAPP_SCAM } from './informative-texts';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FraudAwarenessBanner } from '../fraud-awarenedd-banner.model';

@Component({
    selector: 'app-fraud-awareness-banner-bottom-sheet',
    templateUrl: './fraud-awareness-banner-bottom-sheet.component.html',
    styleUrls: ['./fraud-awareness-banner-bottom-sheet.component.styl']
})
export class FraudAwarenessBannerBottomSheetComponent {
    constructor(
            public dialogRef: MatDialogRef<FraudAwarenessBannerBottomSheetComponent>,
            @Inject(MAT_DIALOG_DATA) public data: {banner: FraudAwarenessBanner}, ) { }

    informativeArray: Informative[] = [INFORMATIVE_MOBILE, INFORMATIVE_ROBBERY, INFORMATIVE_FAKE_CALL_CENTER, INFORMATIVE_WHATSAPP_SCAM];

    get info() {
        return this.informativeArray.find(info => info.id == this.data.banner.id);
    }

    closeBottomSheet(){
        this.dialogRef.close();
    }
}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/fraud-awareness-banner/fraud-awarenned-banner-bottom-sheet/fraud-awareness-banner-bottom-sheet.component.ts